export const translations = {
  English: {
    // Navigation
    'Lessons': 'Lessons',
    'Practice': 'Practice',
    'Account': 'Account',
    'Settings': 'Settings',
    'Admin': 'Admin',
    'Logout': 'Logout',

    // Language Selection
    'Select your languages': 'Select your languages',
    'Target Language': 'Target Language',
    'Your Language': 'Your Language',
    'Continue': 'Continue',
    'Updating...': 'Updating...',

    // Level Selection
    'Select Your Level': 'Select Your Level',
    'Choose your current proficiency level to get started with appropriate lessons.': 'Choose your current proficiency level to get started with appropriate lessons.',
    'Beginner': 'Beginner',
    'Elementary': 'Elementary',
    'Intermediate': 'Intermediate',
    'Upper Intermediate': 'Upper Intermediate',
    'Advanced': 'Advanced',
    'Proficient': 'Proficient',
    'Can understand and use familiar everyday expressions': 'Can understand and use familiar everyday expressions',
    'Can understand sentences and frequently used expressions': 'Can understand sentences and frequently used expressions',
    'Can understand the main points of clear standard input': 'Can understand the main points of clear standard input',
    'Can understand the main ideas of complex text': 'Can understand the main ideas of complex text',
    'Can understand a wide range of demanding, longer texts': 'Can understand a wide range of demanding, longer texts',
    'Can understand with ease virtually everything heard or read': 'Can understand with ease virtually everything heard or read',

    // Lesson List
    'Loading lessons...': 'Loading lessons...',
    'No lessons available': 'No lessons available',
    'Start Lesson': 'Start Lesson',
    'Resume': 'Resume',
    'Completed': 'Completed',

    // Practice
    'Practice Mode': 'Practice Mode',
    'Word Practice': 'Word Practice',
    'Sentence Practice': 'Sentence Practice',
    'Listen and repeat': 'Listen and repeat',
    'Type what you hear': 'Type what you hear',
    'Next': 'Next',
    'Skip': 'Skip',
    'Check': 'Check',
    'Continue to next': 'Continue to next',
    'Lesson Complete!': 'Lesson Complete!',
    'Well done!': 'Well done!',
    'Back to Lessons': 'Back to Lessons',

    // Account
    'Account Information': 'Account Information',
    'Email': 'Email',
    'Learning': 'Learning',
    'Interface Language': 'Interface Language',
    'Current Level': 'Current Level',
    'Lessons Completed': 'Lessons Completed',
    'Member Since': 'Member Since',

    // Settings
    'Language Preferences': 'Language Preferences',
    'Learning Level': 'Learning Level',
    'Save Changes': 'Save Changes',
    'Saving...': 'Saving...',
    'Changes saved successfully': 'Changes saved successfully',

    // Login
    'Welcome': 'Welcome',
    'Sign in to your account': 'Sign in to your account',
    'Email address': 'Email address',
    'Password': 'Password',
    'Sign In': 'Sign In',
    'Sign Up': 'Sign Up',
    'Signing in...': 'Signing in...',
    'Signing up...': 'Signing up...',
    'Don\'t have an account?': 'Don\'t have an account?',
    'Already have an account?': 'Already have an account?',

    // Guide
    'Welcome to Language Learning': 'Welcome to Language Learning',
    'Quick Start Guide': 'Quick Start Guide',
    'Get Started': 'Get Started',

    // Common
    'Loading...': 'Loading...',
    'Error': 'Error',
    'Success': 'Success',
    'Cancel': 'Cancel',
    'Delete': 'Delete',
    'Edit': 'Edit',
    'Add': 'Add',
    'Search': 'Search',
    'Close': 'Close',

    // Continue Learning Prompt
    'Continue Learning': 'Continue Learning',
    'Would you like to continue with your last unlocked lesson?': 'Would you like to continue with your last unlocked lesson?',
    'Not Now': 'Not Now',

    // Lesson Viewer
    'Listen to the Lesson': 'Listen to the Lesson',
    'Stop': 'Stop',
    'Listen': 'Listen',
    'Continue to Practice': 'Continue to Practice',
    'Listen to the lesson first to continue': 'Listen to the lesson first to continue',
    'Tap to Start Audio': 'Tap to Start Audio',
    'Your browser requires interaction to play audio': 'Your browser requires interaction to play audio',
    'Tap the play button to start audio. Your browser requires interaction.': 'Tap the play button to start audio. Your browser requires interaction.',

    // Understanding Survey
    'How much did you understand?': 'How much did you understand?',
    'Drag the slider to indicate your understanding level': 'Drag the slider to indicate your understanding level',
    "Don't understand": "Don't understand",
    'Fully understand': 'Fully understand',
    'How much do you understand now?': 'How much do you understand now?',
    'Initial understanding': 'Initial understanding',
    'Current understanding level': 'Current understanding level',
    'Your improvement': 'Your improvement',
    'You improved by': 'You improved by',
    'Amazing!': 'Amazing!',
    'You understood 100% of the lesson!': 'You understood 100% of the lesson!',
    'Would you like to practice this lesson anyway, or move to the next one?': 'Would you like to practice this lesson anyway, or move to the next one?',
    'Go to Next Lesson': 'Go to Next Lesson',
    'This is the last lesson in your current level.': 'This is the last lesson in your current level.',
    'Practice Anyway': 'Practice Anyway',

    // Sentence Practice
    'Start Recording': 'Start Recording',
    'Stop Recording': 'Stop Recording',
    'Record Again': 'Record Again',
    'Completed ✓': 'Completed ✓',
    'Next Sentence': 'Next Sentence',
    'Typing': 'Typing',
    'Speaking': 'Speaking',
    'Tip: Tap on words to mark them as unknown': 'Tip: Tap on words to mark them as unknown',
    'Tips:': 'Tips:',
    'Switch to type mode if there are issues with recording': 'Switch to type mode if there are issues with recording',
    'You can repeat the same word multiple times to increase the match percentage': 'You can repeat the same word multiple times to increase the match percentage',
    'Sentence': 'Sentence',
    'of': 'of',
    'Build the sentence below': 'Build the sentence below',
    'Listening... Say the sentence in Dutch': 'Listening... Say the sentence in Dutch',
    'Initializing microphone...': 'Initializing microphone...',
    'Speech recognition not available. Please use typing mode.': 'Speech recognition not available. Please use typing mode.',
    'You said:': 'You said:',
    'Match:': 'Match:',
    'Great job!': 'Great job!',
    'You can skip if needed': 'You can skip if needed',
    'Unknown words:': 'Unknown words:',
    'Initializing...': 'Initializing...',

    // Word Test
    'Choose the correct word:': 'Choose the correct word:',

    // Practice Page
    'Complete Lesson Text': 'Complete Lesson Text',

    // Lesson Completion
    '🎉 Congratulations!': '🎉 Congratulations!',
    'You\'ve completed the lesson': 'You\'ve completed the lesson',
    'Next lesson unlocked:': 'Next lesson unlocked:',
    'Continue to Next Lesson': 'Continue to Next Lesson',
    'Great job! You\'ve completed all available lessons for this level.': 'Great job! You\'ve completed all available lessons for this level.',
    'Excellent work!': 'Excellent work!',
    'Great progress!': 'Great progress!',
    'Keep it up!': 'Keep it up!',

    // Statistics
    'Your Performance': 'Your Performance',
    'Sentence pronunciation accuracy': 'Sentence pronunciation accuracy',
    'Average Accuracy': 'Average Accuracy',
    'Perfect Sentences': 'Perfect Sentences',
    'Outstanding pronunciation! Keep up the excellent work!': 'Outstanding pronunciation! Keep up the excellent work!',

    // Report Issue
    'Report Issue': 'Report Issue',
    'Report an Issue': 'Report an Issue',
    'Help us improve this lesson by reporting any issues you found.': 'Help us improve this lesson by reporting any issues you found.',
    'Issue Type': 'Issue Type',
    'Select issue type': 'Select issue type',
    'Content Error': 'Content Error',
    'Audio Issue': 'Audio Issue',
    'Translation Error': 'Translation Error',
    'Technical Issue': 'Technical Issue',
    'Other': 'Other',
    'Description': 'Description',
    'Please describe the issue in detail...': 'Please describe the issue in detail...',
    'Submit Report': 'Submit Report',
    'Submitting...': 'Submitting...',
    'Thank you for your report!': 'Thank you for your report!',
    'Your feedback helps us improve the lessons.': 'Your feedback helps us improve the lessons.',
    'Failed to submit report. Please try again.': 'Failed to submit report. Please try again.',

    // Streak
    'day': 'DAY',
    'days': 'DAYS',
    'day streak': 'day streak',
    'Start Your Journey!': 'Start Your Journey!',
    'Keep It Going!': 'Keep It Going!',
    'Amazing Work!': 'Amazing Work!',
    'Welcome Back!': 'Welcome Back!',
    'Start your streak today!': 'Start your streak today!',
    'Practice today to keep it going!': 'Practice today to keep it going!',
    'You started a streak! Keep it going tomorrow!': 'You started a streak! Keep it going tomorrow!',
    "You're building momentum!": "You're building momentum!",
    'Amazing dedication!': 'Amazing dedication!',
    "You're unstoppable!": "You're unstoppable!",
    'Legendary learner!': 'Legendary learner!',
    'Your best:': 'Your best:',
    'Complete a lesson today to maintain your streak!': 'Complete a lesson today to maintain your streak!',
    "Let's Go!": "Let's Go!",

    // Notifications
    'Push Notifications': 'Push Notifications',
    'Push notifications are available when using the ListenDutch iOS app.': 'Push notifications are available when using the ListenDutch iOS app.',
    'Daily practice reminders': 'Daily practice reminders',
    'Remind me at:': 'Remind me at:',
    'Weekly progress updates': 'Weekly progress updates',
    'New lesson notifications': 'New lesson notifications',
    'Streak alerts': 'Streak alerts',
    'Notification Settings': 'Notification Settings',
    'Daily Reminder': 'Daily Reminder',
    'Get reminded to practice daily': 'Get reminded to practice daily',
    'Reminder Time': 'Reminder Time',
    'Hour': 'Hour',
    'Minute': 'Minute',
    'Done': 'Done',
    'Your timezone': 'Your timezone',
    'Streak Alerts': 'Streak Alerts',
    'Get notified about your streak': 'Get notified about your streak',
    'New Lessons': 'New Lessons',
    'Get notified when new lessons are available': 'Get notified when new lessons are available',
    'Weekly Progress': 'Weekly Progress',
    'Receive weekly progress summaries': 'Receive weekly progress summaries',
    'Settings saved!': 'Settings saved!',
    'Error saving settings': 'Error saving settings',
    'Reminder time updated!': 'Reminder time updated!',
    'Error updating time': 'Error updating time',
    'Unable to load notification settings': 'Unable to load notification settings',

    // Custom Lessons
    'Custom Lessons': 'Custom Lessons',
    'Your personal AI-generated lessons': 'Your personal AI-generated lessons',
    'Or create your own': 'Or create your own',
    'Create Lesson': 'Create Lesson',
    'In Progress': 'In Progress',
    'Waiting...': 'Waiting...',
    'Generating text...': 'Generating text...',
    'Analyzing content...': 'Analyzing content...',
    'Creating audio...': 'Creating audio...',
    'No custom lessons yet': 'No custom lessons yet',
    'Create your first AI-powered lesson': 'Create your first AI-powered lesson',
    'Create Your First Lesson': 'Create Your First Lesson',
    'Are you sure you want to delete this lesson?': 'Are you sure you want to delete this lesson?',
    'Create Custom Lesson': 'Create Custom Lesson',
    'How would you like to create your lesson?': 'How would you like to create your lesson?',
    'I have Dutch text': 'I have Dutch text',
    'Paste your own Dutch text to create a lesson': 'Paste your own Dutch text to create a lesson',
    'Generate with AI': 'Generate with AI',
    'Describe a topic and AI will create Dutch text': 'Describe a topic and AI will create Dutch text',
    'Dutch Text': 'Dutch Text',
    'Paste your Dutch text here...': 'Paste your Dutch text here...',
    'words': 'words',
    'Topic or Description': 'Topic or Description',
    'Describe what you want to learn about... (in any language)': 'Describe what you want to learn about... (in any language)',
    'Approximate Word Count': 'Approximate Word Count',
    'Short': 'Short',
    'Medium': 'Medium',
    'Long': 'Long',
    'lesson': 'lesson',
    'Please enter text or a topic': 'Please enter text or a topic',
    'Something went wrong': 'Something went wrong',
    'Creating...': 'Creating...',
    'This may take a few minutes': 'This may take a few minutes',
    'AI-Generated Lesson': 'AI-Generated Lesson',
    'Custom Lesson': 'Custom Lesson',
    'Translation Language': 'Translation Language',
    'Sentences will be translated to this language': 'Sentences will be translated to this language',
    'Beginner - Basic phrases and expressions': 'Beginner - Basic phrases and expressions',
    'Elementary - Simple conversations': 'Elementary - Simple conversations',
    'Intermediate - Express opinions': 'Intermediate - Express opinions',
    'Upper Intermediate - Complex topics': 'Upper Intermediate - Complex topics',
    'Advanced - Fluent expression': 'Advanced - Fluent expression',
  },

  Persian: {
    // Navigation
    'Lessons': 'درس‌ها',
    'Practice': 'تمرین',
    'Account': 'حساب کاربری',
    'Settings': 'تنظیمات',
    'Admin': 'مدیریت',
    'Logout': 'خروج',

    // Language Selection
    'Select your languages': 'زبان‌های خود را انتخاب کنید',
    'Target Language': 'زبان مقصد',
    'Your Language': 'زبان شما',
    'Continue': 'ادامه',
    'Updating...': 'در حال به‌روزرسانی...',

    // Level Selection
    'Select Your Level': 'سطح خود را انتخاب کنید',
    'Choose your current proficiency level to get started with appropriate lessons.': 'سطح مهارت فعلی خود را برای شروع با درس‌های مناسب انتخاب کنید.',
    'Beginner': 'مبتدی',
    'Elementary': 'ابتدایی',
    'Intermediate': 'متوسط',
    'Upper Intermediate': 'متوسط به بالا',
    'Advanced': 'پیشرفته',
    'Proficient': 'ماهر',
    'Can understand and use familiar everyday expressions': 'می‌تواند عبارات روزمره آشنا را درک و استفاده کند',
    'Can understand sentences and frequently used expressions': 'می‌تواند جملات و عبارات پرکاربرد را درک کند',
    'Can understand the main points of clear standard input': 'می‌تواند نکات اصلی ورودی استاندارد واضح را درک کند',
    'Can understand the main ideas of complex text': 'می‌تواند ایده‌های اصلی متن پیچیده را درک کند',
    'Can understand a wide range of demanding, longer texts': 'می‌تواند طیف گسترده‌ای از متون طولانی و دشوار را درک کند',
    'Can understand with ease virtually everything heard or read': 'می‌تواند به راحتی تقریباً هر چیزی را که می‌شنود یا می‌خواند درک کند',

    // Lesson List
    'Loading lessons...': 'در حال بارگذاری درس‌ها...',
    'No lessons available': 'هیچ درسی موجود نیست',
    'Start Lesson': 'شروع درس',
    'Resume': 'ادامه',
    'Completed': 'تکمیل شده',

    // Practice
    'Practice Mode': 'حالت تمرین',
    'Word Practice': 'تمرین لغت',
    'Sentence Practice': 'تمرین جمله',
    'Listen and repeat': 'گوش کنید و تکرار کنید',
    'Type what you hear': 'آنچه می‌شنوید تایپ کنید',
    'Next': 'بعدی',
    'Skip': 'رد شدن',
    'Check': 'بررسی',
    'Continue to next': 'ادامه به بعدی',
    'Lesson Complete!': 'درس تکمیل شد!',
    'Well done!': 'آفرین!',
    'Back to Lessons': 'بازگشت به درس‌ها',

    // Account
    'Account Information': 'اطلاعات حساب کاربری',
    'Email': 'ایمیل',
    'Learning': 'در حال یادگیری',
    'Interface Language': 'زبان رابط کاربری',
    'Current Level': 'سطح فعلی',
    'Lessons Completed': 'درس‌های تکمیل شده',
    'Member Since': 'عضو از تاریخ',

    // Settings
    'Language Preferences': 'ترجیحات زبان',
    'Learning Level': 'سطح یادگیری',
    'Save Changes': 'ذخیره تغییرات',
    'Saving...': 'در حال ذخیره...',
    'Changes saved successfully': 'تغییرات با موفقیت ذخیره شد',

    // Login
    'Welcome': 'خوش آمدید',
    'Sign in to your account': 'وارد حساب کاربری خود شوید',
    'Email address': 'آدرس ایمیل',
    'Password': 'رمز عبور',
    'Sign In': 'ورود',
    'Sign Up': 'ثبت نام',
    'Signing in...': 'در حال ورود...',
    'Signing up...': 'در حال ثبت نام...',
    'Don\'t have an account?': 'حساب کاربری ندارید؟',
    'Already have an account?': 'قبلاً حساب کاربری دارید؟',

    // Guide
    'Welcome to Language Learning': 'به یادگیری زبان خوش آمدید',
    'Quick Start Guide': 'راهنمای شروع سریع',
    'Get Started': 'شروع کنید',

    // Common
    'Loading...': 'در حال بارگذاری...',
    'Error': 'خطا',
    'Success': 'موفقیت',
    'Cancel': 'لغو',
    'Delete': 'حذف',
    'Edit': 'ویرایش',
    'Add': 'افزودن',
    'Search': 'جستجو',
    'Close': 'بستن',

    // Continue Learning Prompt
    'Continue Learning': 'ادامه یادگیری',
    'Would you like to continue with your last unlocked lesson?': 'آیا می‌خواهید با آخرین درس باز شده خود ادامه دهید؟',
    'Not Now': 'الان نه',

    // Lesson Viewer
    'Listen to the Lesson': 'گوش دادن به درس',
    'Stop': 'توقف',
    'Listen': 'گوش کردن',
    'Continue to Practice': 'ادامه به تمرین',
    'Listen to the lesson first to continue': 'ابتدا به درس گوش دهید تا ادامه دهید',
    'Tap to Start Audio': 'برای شروع صدا ضربه بزنید',
    'Your browser requires interaction to play audio': 'مرورگر شما برای پخش صدا نیاز به تعامل دارد',
    'Tap the play button to start audio. Your browser requires interaction.': 'برای شروع صدا، دکمه پخش را بزنید. مرورگر شما نیاز به تعامل دارد.',

    // Understanding Survey
    'How much did you understand?': 'چقدر متوجه شدید؟',
    'Drag the slider to indicate your understanding level': 'نوار لغزنده را بکشید تا سطح درک خود را نشان دهید',
    "Don't understand": 'متوجه نشدم',
    'Fully understand': 'کاملاً متوجه شدم',
    'How much do you understand now?': 'الان چقدر متوجه شدید؟',
    'Initial understanding': 'درک اولیه',
    'Current understanding level': 'سطح درک فعلی',
    'Your improvement': 'پیشرفت شما',
    'You improved by': 'شما پیشرفت کردید',
    'Amazing!': 'فوق‌العاده!',
    'You understood 100% of the lesson!': 'شما ۱۰۰٪ درس را متوجه شدید!',
    'Would you like to practice this lesson anyway, or move to the next one?': 'آیا می‌خواهید به هر حال این درس را تمرین کنید یا به درس بعدی بروید؟',
    'Go to Next Lesson': 'رفتن به درس بعدی',
    'This is the last lesson in your current level.': 'این آخرین درس در سطح فعلی شماست.',
    'Practice Anyway': 'به هر حال تمرین کنید',

    // Sentence Practice
    'Start Recording': 'شروع ضبط',
    'Stop Recording': 'توقف ضبط',
    'Record Again': 'ضبط مجدد',
    'Completed ✓': 'تکمیل شد ✓',
    'Next Sentence': 'جمله بعدی',
    'Typing': 'تایپ کردن',
    'Speaking': 'صحبت کردن',
    'Tip: Tap on words to mark them as unknown': 'نکته: روی کلمات ضربه بزنید تا به عنوان ناشناخته علامت‌گذاری شوند',
    'Tips:': 'نکات:',
    'Switch to type mode if there are issues with recording': 'در صورت مشکل در ضبط صدا به حالت تایپ بروید',
    'You can repeat the same word multiple times to increase the match percentage': 'می‌توانید یک کلمه را چند بار تکرار کنید تا درصد تطابق افزایش یابد',
    'Sentence': 'جمله',
    'of': 'از',
    'Build the sentence below': 'جمله زیر را بسازید',
    'Listening... Say the sentence in Dutch': 'در حال گوش دادن... جمله را به هلندی بگویید',
    'Initializing microphone...': 'راه‌اندازی میکروفون...',
    'Speech recognition not available. Please use typing mode.': 'تشخیص گفتار در دسترس نیست. لطفاً از حالت تایپ استفاده کنید.',
    'You said:': 'شما گفتید:',
    'Match:': 'تطابق:',
    'Great job!': 'عالی بود!',
    'You can skip if needed': 'در صورت نیاز می‌توانید رد شوید',
    'Unknown words:': 'کلمات ناشناخته:',
    'Initializing...': 'در حال راه‌اندازی...',

    // Word Test
    'Choose the correct word:': 'کلمه صحیح را انتخاب کنید:',

    // Practice Page
    'Complete Lesson Text': 'متن کامل درس',

    // Lesson Completion
    '🎉 Congratulations!': '🎉 تبریک می‌گویم!',
    'You\'ve completed the lesson': 'شما درس را تکمیل کردید',
    'Next lesson unlocked:': 'درس بعدی باز شد:',
    'Continue to Next Lesson': 'ادامه به درس بعدی',
    'Great job! You\'ve completed all available lessons for this level.': 'عالی بود! شما تمام درس‌های موجود برای این سطح را تکمیل کردید.',
    'Excellent work!': 'کار فوق‌العاده‌ای انجام دادید!',
    'Great progress!': 'پیشرفت عالی!',
    'Keep it up!': 'ادامه دهید!',

    // Statistics
    'Your Performance': 'عملکرد شما',
    'Sentence pronunciation accuracy': 'دقت تلفظ جمله',
    'Average Accuracy': 'میانگین دقت',
    'Perfect Sentences': 'جملات کامل',
    'Outstanding pronunciation! Keep up the excellent work!': 'تلفظ عالی! به کار فوق‌العاده خود ادامه دهید!',

    // Report Issue
    'Report Issue': 'گزارش مشکل',
    'Report an Issue': 'گزارش یک مشکل',
    'Help us improve this lesson by reporting any issues you found.': 'با گزارش مشکلاتی که پیدا کردید به ما کمک کنید این درس را بهبود دهیم.',
    'Issue Type': 'نوع مشکل',
    'Select issue type': 'نوع مشکل را انتخاب کنید',
    'Content Error': 'خطای محتوا',
    'Audio Issue': 'مشکل صوتی',
    'Translation Error': 'خطای ترجمه',
    'Technical Issue': 'مشکل فنی',
    'Other': 'سایر',
    'Description': 'توضیحات',
    'Please describe the issue in detail...': 'لطفاً مشکل را به تفصیل شرح دهید...',
    'Submit Report': 'ارسال گزارش',
    'Submitting...': 'در حال ارسال...',
    'Thank you for your report!': 'از گزارش شما متشکریم!',
    'Your feedback helps us improve the lessons.': 'بازخورد شما به ما کمک می‌کند درس‌ها را بهبود دهیم.',
    'Failed to submit report. Please try again.': 'ارسال گزارش ناموفق بود. لطفاً دوباره تلاش کنید.',

    // Streak
    'day': 'روز',
    'days': 'روز',
    'day streak': 'روز متوالی',
    'Start Your Journey!': 'سفر خود را شروع کنید!',
    'Keep It Going!': 'ادامه دهید!',
    'Amazing Work!': 'کار فوق‌العاده!',
    'Welcome Back!': 'خوش آمدید!',
    'Start your streak today!': 'امروز دوره متوالی خود را شروع کنید!',
    'Practice today to keep it going!': 'امروز تمرین کنید تا ادامه پیدا کند!',
    'You started a streak! Keep it going tomorrow!': 'دوره متوالی خود را شروع کردید! فردا ادامه دهید!',
    "You're building momentum!": 'در حال پیشرفت هستید!',
    'Amazing dedication!': 'تعهد فوق‌العاده!',
    "You're unstoppable!": 'شما متوقف نشدنی هستید!',
    'Legendary learner!': 'یادگیرنده افسانه‌ای!',
    'Your best:': 'بهترین شما:',
    'Complete a lesson today to maintain your streak!': 'امروز یک درس تکمیل کنید تا دوره متوالی خود را حفظ کنید!',
    "Let's Go!": 'بزن بریم!',

    // Notifications
    'Push Notifications': 'اطلاعیه‌های فوری',
    'Push notifications are available when using the ListenDutch iOS app.': 'اطلاعیه‌های فوری در هنگام استفاده از برنامه ListenDutch iOS موجود هستند.',
    'Daily practice reminders': 'یادآوری‌های تمرین روزانه',
    'Remind me at:': 'یادآوری کن در:',
    'Weekly progress updates': 'به‌روزرسانی‌های پیشرفت هفتگی',
    'New lesson notifications': 'اطلاعیه‌های درس جدید',
    'Streak alerts': 'هشدارهای دوره متوالی',
    'Notification Settings': 'تنظیمات اطلاعیه',
    'Daily Reminder': 'یادآوری روزانه',
    'Get reminded to practice daily': 'یادآوری برای تمرین روزانه دریافت کنید',
    'Reminder Time': 'زمان یادآوری',
    'Hour': 'ساعت',
    'Minute': 'دقیقه',
    'Done': 'تمام',
    'Your timezone': 'منطقه زمانی شما',
    'Streak Alerts': 'هشدارهای دوره متوالی',
    'Get notified about your streak': 'در مورد دوره متوالی خود مطلع شوید',
    'New Lessons': 'درس‌های جدید',
    'Get notified when new lessons are available': 'هنگام در دسترس بودن درس‌های جدید مطلع شوید',
    'Weekly Progress': 'پیشرفت هفتگی',
    'Receive weekly progress summaries': 'خلاصه پیشرفت هفتگی دریافت کنید',
    'Settings saved!': 'تنظیمات ذخیره شد!',
    'Error saving settings': 'خطا در ذخیره تنظیمات',
    'Reminder time updated!': 'زمان یادآوری به‌روزرسانی شد!',
    'Error updating time': 'خطا در به‌روزرسانی زمان',
    'Unable to load notification settings': 'بارگذاری تنظیمات اطلاعیه ممکن نیست',

    // Custom Lessons
    'Custom Lessons': 'درس‌های سفارشی',
    'Your personal AI-generated lessons': 'درس‌های شخصی تولید شده با هوش مصنوعی',
    'Or create your own': 'یا خودتان بسازید',
    'Create Lesson': 'ساخت درس',
    'In Progress': 'در حال انجام',
    'Waiting...': 'در انتظار...',
    'Generating text...': 'در حال تولید متن...',
    'Analyzing content...': 'در حال تحلیل محتوا...',
    'Creating audio...': 'در حال ساخت صدا...',
    'No custom lessons yet': 'هنوز درس سفارشی ندارید',
    'Create your first AI-powered lesson': 'اولین درس هوش مصنوعی خود را بسازید',
    'Create Your First Lesson': 'اولین درس خود را بسازید',
    'Are you sure you want to delete this lesson?': 'آیا مطمئن هستید که می‌خواهید این درس را حذف کنید؟',
    'Create Custom Lesson': 'ساخت درس سفارشی',
    'How would you like to create your lesson?': 'چگونه می‌خواهید درس خود را بسازید؟',
    'I have Dutch text': 'متن هلندی دارم',
    'Paste your own Dutch text to create a lesson': 'متن هلندی خود را برای ساخت درس بچسبانید',
    'Generate with AI': 'تولید با هوش مصنوعی',
    'Describe a topic and AI will create Dutch text': 'موضوعی را توصیف کنید و هوش مصنوعی متن هلندی می‌سازد',
    'Dutch Text': 'متن هلندی',
    'Paste your Dutch text here...': 'متن هلندی خود را اینجا بچسبانید...',
    'words': 'کلمه',
    'Topic or Description': 'موضوع یا توضیحات',
    'Describe what you want to learn about... (in any language)': 'توضیح دهید درباره چه می‌خواهید یاد بگیرید... (به هر زبانی)',
    'Approximate Word Count': 'تعداد تقریبی کلمات',
    'Short': 'کوتاه',
    'Medium': 'متوسط',
    'Long': 'بلند',
    'lesson': 'درس',
    'Please enter text or a topic': 'لطفاً متن یا موضوعی وارد کنید',
    'Something went wrong': 'مشکلی پیش آمد',
    'Creating...': 'در حال ساخت...',
    'This may take a few minutes': 'این ممکن است چند دقیقه طول بکشد',
    'AI-Generated Lesson': 'درس تولید شده با هوش مصنوعی',
    'Custom Lesson': 'درس سفارشی',
    'Translation Language': 'زبان ترجمه',
    'Sentences will be translated to this language': 'جملات به این زبان ترجمه خواهند شد',
    'Beginner - Basic phrases and expressions': 'مبتدی - عبارات و جملات پایه',
    'Elementary - Simple conversations': 'ابتدایی - مکالمات ساده',
    'Intermediate - Express opinions': 'متوسط - بیان نظرات',
    'Upper Intermediate - Complex topics': 'متوسط به بالا - موضوعات پیچیده',
    'Advanced - Fluent expression': 'پیشرفته - بیان روان',
  }
};

export type TranslationKey = keyof typeof translations.English;
export type Language = keyof typeof translations;

export function getTranslation(key: TranslationKey, language: Language = 'English'): string {
  return translations[language]?.[key] || translations.English[key] || key;
}

export function useTranslation(nativeLanguage?: string) {
  const language = (nativeLanguage === 'Persian' ? 'Persian' : 'English') as Language;

  return {
    t: (key: TranslationKey) => getTranslation(key, language),
    language,
    isRTL: language === 'Persian'
  };
}
